module.exports = __webpack_public_path__ + "static/media/u17.e486927b.svg";